import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserBillingEur = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "-1.8 -1.8 21.6 21.6",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m7.75-9a7.75 7.75 0 1 1-15.5 0 7.75 7.75 0 0 1 15.5 0m-9.254 4.684a4.3 4.3 0 0 0 1.694.322q.686 0 1.218-.168.531-.153.938-.42.42-.278.714-.644.308-.378.518-.784l-1.176-.826q-.322.714-.868 1.12t-1.344.406q-.939 0-1.554-.546-.603-.546-.798-1.512h3.416V9.554H6.768V8.35h3.486V7.272H6.838q.195-.937.798-1.498.615-.56 1.554-.56.77 0 1.288.378.531.378.826 1.05l1.176-.798a4.06 4.06 0 0 0-1.232-1.4q-.771-.546-2.058-.546-.939 0-1.694.336-.757.336-1.288.98-.532.645-.826 1.582-.28.939-.28 2.156t.28 2.156q.293.939.826 1.596.531.645 1.288.98" })
});
export default SvgUserBillingEur;
